module.exports = __webpack_public_path__ + "img/confused.72d54564.gif";